<template>
    <div>
        <pagamento
            :pagamento="pagamento"
            :pagamentosServicos="obterPagamentosServicos()"
            v-show="mostrarPagamento"
            @obterPagamentoAtualizado="obterPagamentoAtualizado()"
        >
            <template slot="consultoriasBotoes">
                <b-button-group class="float-right">
                    <b-button
                        variant="primary"
                        @click="carregarAssociarConsultorias()"
                        v-if="mostrarBtnAssociarConsultorias"
                        ><i class="fa fa-plus"></i> Associar
                        Consultorias</b-button
                    >
                </b-button-group>
            </template>
            <template slot="consultoriaAcoes" slot-scope="data">
                <span class="text-primary">
                    <i
                        class="fa fa-info-circle fa-lg icon-button"
                        title="Detalhar"
                        @click.stop="detalhar(data.consultoriaId)"
                    ></i>
                </span>
            </template>
        </pagamento>
        <router-view
            v-if="pagamento"
            :pagamento="pagamento"
            @obterPagamentoAtualizado="obterPagamentoAtualizado()"
        ></router-view>
    </div>
</template>

<script>
import PagamentosServicos from './PagamentosServicos'
import Pagamento from '@/app/appsebrae/consultorias/componentes/pagamentos/Pagamento'
import { pagamentoStatus } from '@/app/appsebrae/consultorias/componentes/pagamentos/PagamentoStatus'

export default {
    data() {
        return {
            pagamento: {}
        }
    },

    methods: {
        obterPagamento() {
            this.$store.dispatch('addRequest')
            PagamentosServicos.obterPorId(this.$route.params.pagamentoId).then(
                response => {
                    if (response) {
                        if (response.success) {
                            this.pagamento = response.data
                        } else {
                            this.$toast.error(
                                'Não foi possível obter o pagamento.',
                                'ERROR',
                                this.$toastConfig.error
                            )
                        }
                    }
                    this.$store.dispatch('removeRequest')
                }
            )
        },

        obterPagamentosServicos() {
            return PagamentosServicos
        },

        detalhar(consultoriaId) {
            this.$router.push({
                name: 'AppSebrae_Consultorias_Fornecedor_Consultorias_Detalhar',
                params: {
                    consultoriaId: consultoriaId
                }
            })
        },

        obterPagamentoAtualizado() {
            this.obterPagamento()
            this.$store.dispatch('setRecarregar', true)
        },

        carregarAssociarConsultorias() {
            this.$router.push({
                name:
                    'AppSebrae_Consultorias_Fornecedor_Pagamentos_AssociarConsultorias'
            })
        }
    },

    computed: {
        mostrarBtnAssociarConsultorias() {
            return (
                (this.pagamento.status === pagamentoStatus.CRIADO ||
                    this.pagamento.status === pagamentoStatus.REPROVADO) &&
                this.$temAcesso('APPSE-FORN-PAG-03')
            )
        },

        mostrarPagamento() {
            return (
                this.$route.name ===
                'AppSebrae_Consultorias_Fornecedor_Pagamentos_Detalhar'
            )
        }
    },

    components: {
        Pagamento: Pagamento
    },

    created() {
        this.obterPagamento()
    }
}
</script>
